import type { Phrases } from './Phrases.d';

import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useRef } from 'react';
import { FontAwesomeIconWrapper } from '/react4xp/components/FontAwesomeIconWrapper';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span, cn } from '../../../components/Element';
import { TextArea } from '../../../components/react-hook-form/TextArea';
import { COMMON_FIELD_NAME } from './constants';


export const AdditionalInformationTextArea = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const { setScrollRef } = useFormContext();
	const label = phrases['notificationForm.common.additionalInformationField.label'];

	const scrollRef = useRef<HTMLTextAreaElement>();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.ADDITIONAL_INFORMATION, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<TextArea
			aria-label={label} // Since label below is !string, but ReactNode.
			description={
				<Span>
					<FontAwesomeIconWrapper className={cn({color: 'iconFeedbackInfoDefault'})} icon={faCircleInfo}/>
					&nbsp;
					{phrases['notificationForm.term.doNotEnterPersonalInformation']}
				</Span>
			}
			errorSummaryLabel={label}
			label={
				<Span
					className='font-semibold text-xl'
					elementRef={scrollRef}
				>{label}</Span>
			}
			name={COMMON_FIELD_NAME.ADDITIONAL_INFORMATION}
		/>
	);
};
